import { useAuth } from "@/context/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, Users, LayoutGrid } from "lucide-react";

export default function TopBar() {
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const doLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-30 bg-white/85 backdrop-blur-md border-b border-border">
      <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/dashboard" className="flex items-center gap-3" data-testid="logo-link">
          <div className="h-8 w-8 bg-foreground text-background grid place-items-center font-heading font-semibold text-sm">
            O3
          </div>
          <div className="leading-none">
            <p className="font-heading font-semibold tracking-tight">Ordine3</p>
            <p className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground">Gestionale</p>
          </div>
        </Link>

        <nav className="flex items-center gap-1">
          <Link to="/dashboard">
            <Button
              variant="ghost"
              size="sm"
              data-testid="nav-projects"
              className={`rounded-none gap-2 ${location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/projects") ? "text-foreground" : "text-muted-foreground"}`}
            >
              <LayoutGrid className="h-4 w-4" /> Progetti
            </Button>
          </Link>
          {isAdmin && (
            <Link to="/utenti">
              <Button
                variant="ghost"
                size="sm"
                data-testid="nav-users"
                className={`rounded-none gap-2 ${location.pathname === "/utenti" ? "text-foreground" : "text-muted-foreground"}`}
              >
                <Users className="h-4 w-4" /> Utenti
              </Button>
            </Link>
          )}
          <div className="mx-3 h-6 w-px bg-border" />
          <div className="text-right mr-2 hidden sm:block">
            <p className="text-sm font-medium leading-none">{user?.name}</p>
            <p className="text-[10px] uppercase tracking-wider text-muted-foreground">
              {isAdmin ? "Amministratore" : "Collaboratore"}
            </p>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={doLogout}
            data-testid="logout-button"
            className="rounded-none gap-2"
          >
            <LogOut className="h-4 w-4" /> Esci
          </Button>
        </nav>
      </div>
    </header>
  );
}
